import { useMutation } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { RevealedNameData } from "@/hooks/queries/client-types";

// Reveal-on-demand name (Story 5.4). A MUTATION, not a query: each call writes a
// `client.client.name_revealed` audit event server-side, so it must be 1:1 with a
// deliberate clinician action — never auto-fired on mount, never batched across a
// page. The decrypted name lives only in the caller's component state (PHI; never
// logged, never persisted).
//
// `skipAuthRefresh` is OMITTED — this is a post-session data call that rides the
// silent-refresh path.

export function useRevealClientName() {
  return useMutation({
    mutationFn: (clientId: string) =>
      apiFetch<RevealedNameData>(`/clients/${clientId}/reveal-name`, { method: "POST" }),
  });
}
